import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import MultiBackend, { TouchTransition } from 'react-dnd-multi-backend';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';
import { DragDropContext } from 'react-dnd';

import { queryMap, queryKeys } from '@simple-city/service-graphql-schemas';

import * as actions from '../actions';

import DefaultLayout from '../layouts/Default';

const mapStateToProps = ({ auth: { profile }, network, breadcrumb }) => ({ profile, network, breadcrumb });

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

const HTML5toTouch = {
  backends: [
    {
      backend: HTML5Backend,
    },
    {
      backend: TouchBackend({ enableMouseEvents: true, delayTouchStart: 100 }),
      preview: true,
      transition: TouchTransition,
    },
  ],
};

const withData = graphql(queryMap[queryKeys.Q_ME])(DefaultLayout);

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(withData);

export default DragDropContext(MultiBackend(HTML5toTouch))(AppContainer);



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js